import React from 'react';
import {Box, Button, Typography} from "@mui/material";
import {ReactComponent as DeleteIcon} from "../../../assets/flyersScreen/delete_icon.svg";

interface Props {
    value: string;
    removeItem: (itemValue: string) => void;
}

export const InputResult: React.FC<Props> = ({
                                                 value,
                                                 removeItem,
                                             }) => {

    const onDelete = () => {
        removeItem(value)
    }
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                columnGap: "4px",
                padding: "4px 8px",
                backgroundColor: "#014780"
            }}
        >
            <Typography color={"#ffffff"}>{value}</Typography>
            <Button
                onClick={onDelete}
                sx={{
                    padding: "4px",
                    "& > svg path": {
                        fill: "#ffffff"
                    },
                    "&:hover": {
                        backgroundColor: "#FFFFFF80",
                    },
                }}
            >
                <DeleteIcon/>
            </Button>
        </Box>
    )
}